/**
 * Global Notification Service
 * Any component can import notificationService and call notify() to display a notification.
 */

import { Subject } from 'rxjs';

export interface Notification {
  message: string;
  // You can have different severity types: 'default' (or 'info') by default, or 'error' / 'warning' / 'success'
  type: 'error' | 'warning' | 'info' | 'success';
  duration?: number; // Duration in milliseconds, default is 30s
  action?: () => void;
  actionText?: string;
}

export class NotificationService {
  // Internal subject to push notifications
  private notificationSubject = new Subject<Notification>();

  // Observable that components can subscribe to in order to display notifications
  notifications$ = this.notificationSubject.asObservable();

  // Call this method from anywhere to trigger a notification
  notify(notification: Notification) {
    this.notificationSubject.next(notification);
  }
}

// Export a single global instance
export const notificationService = new NotificationService();
